import { fork } from 'redux-saga/effects';

import authSaga from './api-auth/saga';
import usersSaga from './users/saga';
import UserSaga from './user/saga';
import UserInfoToModifySaga from './user-info-to-modify/saga';
import resetPasswordSaga from './reset-password/saga';
import CirculationsSaga from './circulations/saga';
import stationsSaga from './stations/saga';
import StationsServed from './stations-served/saga';
import ReasonsSaga from './reasons/saga';
import ProductCodesSaga from './product-codes/saga';
import ProductCodeSaga from './product-code/saga';
import HelpInfosSaga from './help-infos/saga';
import HelpInfoSaga from './help-info/saga';
import ReasonSaga from './reason/saga';
import CustomersListSaga from './customers-list/saga';
// Communication ------------------------------------------------------------------------------
import StationsTemplatesPreview from './stations-templates-preview/saga';
import HistoricCommunication from './historic-communication/saga';
import HistoricPendingCommunication from './historic-pending-communication/saga';
import ServicesPassengersConcernedByCommunicationSaga from './communication-impacted-passengers/saga';
import LatestCommmunication from './latest-communication/saga';
import SendCommunicationSaga from './send-communication/saga';
// --------------------------------------------------------------------------------------------
import ApiVersion from './api-version/saga';
import SituationsSaga from './situations/saga';
import SituationsCommunicationsSaga from './situations-communications/saga';
import SituationsCategorySaga from './situations-category/saga';
import SituationCategorySaga from './situation-category/saga';
import Situation from './situation/saga';
import MasksSaga from './masks/saga';
import MaskSaga from './mask/saga';
import MasksConfigSaga from './masks-config/saga';
import Profiles from './profiles/saga';
import Groups from './groups/saga';
import OtherSelectionSaga from './other-selection/saga';
import TypologySaga from './typology/saga';
import CompensationSentencesSaga from './compensation-sentences/saga';
import CompensationSentenceSaga from './compensation-sentence/saga';
import MessagesMasksSaga from './messages-mask/saga';
import ProfilSaga from './profil/saga';
import SectionsSaga from './sections/saga';
import keywordsSaga from './keywords/saga';
import sendStatusSaga from './send-status/saga';
import serviceTypesSaga from './service-types/saga';
import translationLenguagesSaga from './translation-languages/saga';

export default function* rootSaga() {
  yield fork(authSaga);
  yield fork(usersSaga);
  yield fork(UserSaga);
  yield fork(UserInfoToModifySaga);
  yield fork(resetPasswordSaga);
  yield fork(CirculationsSaga);
  yield fork(stationsSaga);
  yield fork(StationsServed);
  yield fork(ReasonsSaga);
  yield fork(ProductCodesSaga);
  yield fork(ProductCodeSaga);
  yield fork(HelpInfosSaga);
  yield fork(HelpInfoSaga);
  yield fork(ReasonSaga);
  yield fork(CustomersListSaga);
  // Communication --------------------------------------
  yield fork(StationsTemplatesPreview);
  yield fork(HistoricCommunication);
  yield fork(HistoricPendingCommunication);
  yield fork(ServicesPassengersConcernedByCommunicationSaga);
  yield fork(SendCommunicationSaga);
  // ----------------------------------------------------
  yield fork(LatestCommmunication);
  yield fork(ApiVersion);
  yield fork(SituationsSaga);
  yield fork(SituationsCommunicationsSaga);
  yield fork(SituationsCategorySaga);
  yield fork(SituationCategorySaga);
  yield fork(Situation);
  yield fork(MasksSaga);
  yield fork(MaskSaga);
  yield fork(MasksConfigSaga);
  yield fork(Profiles);
  yield fork(Groups);
  yield fork(OtherSelectionSaga);
  yield fork(TypologySaga);
  yield fork(CompensationSentencesSaga);
  yield fork(CompensationSentenceSaga);
  yield fork(MessagesMasksSaga);
  yield fork(ProfilSaga);
  yield fork(SectionsSaga);
  yield fork(keywordsSaga);
  yield fork(sendStatusSaga);
  yield fork(serviceTypesSaga);
  yield fork(translationLenguagesSaga);
}
